import { GET_FACILITY_API } from '../commons/constants/apis';
import { ResponseTypes } from '../types/response/common';
import { FacilityResponseTypes } from '../types/response/facility';
import axios from './axios';

export const getFacilityByKey = async (
  key: string,
  language: string
): Promise<FacilityResponseTypes> => {
  const { data }: ResponseTypes<FacilityResponseTypes> = await axios.get(
    `${GET_FACILITY_API}/${key}`,
    {
      headers: { language },
    }
  );
  return data;
};
